import { useDroppable } from "@dnd-kit/core";
import { AuctionTableRow } from "./AuctionTableRow";

export const DroppableAuctionTableRow = ({ dataRow, index }) => {

    const {isOver, setNodeRef} = useDroppable({
        id: `row-${dataRow.id}`,
        data: {
            id: dataRow.id,
            index
        }
    });

    return (
        <AuctionTableRow 
            className="auction-table-row"
            ref={setNodeRef}
            key={dataRow.id}
            dataRow={dataRow}
            index={index}
            data-over={isOver ? "true" : "false"}
            // style={{background: isOver ? '#333333' : ''}}
        />
    )
}